import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const POLL_TYPES: Record<string, string> = {
  yes_no: 'Тийм/Үгүй', multiple_choice: 'Олон сонголт', ranked: 'Эрэмбэлсэн',
};
const STATUS_COLORS: Record<string, string> = {
  draft: '#6b7280', active: '#10b981', closed: '#3b82f6',
};

export default function GovernancePage() {
  const [polls, setPolls] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    title: '', description: '', poll_type: 'yes_no', quorum_percent: '51',
    options: ['Тийм', 'Үгүй'],
  });

  const loadPolls = () => {
    api.get('/admin/polls').then(res => setPolls(Array.isArray(res) ? res : res?.items || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(loadPolls, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/admin/polls', {
      ...form,
      quorum_percent: parseInt(form.quorum_percent) || 51,
      options: form.options.filter(o => o.trim()).map((label, i) => ({ label, sort_order: i })),
    });
    setShowForm(false);
    setForm({ title: '', description: '', poll_type: 'yes_no', quorum_percent: '51', options: ['Тийм', 'Үгүй'] });
    loadPolls();
  };

  const activatePoll = async (id: string) => {
    await api.post(`/admin/polls/${id}/activate`);
    loadPolls();
  };

  const closePoll = async (id: string) => {
    await api.post(`/admin/polls/${id}/close`);
    loadPolls();
  };

  const deletePoll = async (poll: any) => {
    const n = poll.total_voted || 0;
    if (!window.confirm(`«${poll.title}» санал асуулгыг устгах уу?${n ? ` Өгсөн ${n} санал хамт устана.` : ''} Буцаах боломжгүй.`)) return;
    try { await api.delete(`/admin/polls/${poll.id}`); loadPolls(); }
    catch { window.alert('Устгаж чадсангүй'); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>Санал асуулга</h2>
        <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>
          {showForm ? 'Болих' : '+ Шинэ санал'}
        </button>
      </div>

      {showForm && (
        <div style={card}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={labelStyle}>Гарчиг</label>
                <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Төрөл</label>
                <select value={form.poll_type} onChange={e => setForm({ ...form, poll_type: e.target.value })} style={inputStyle}>
                  <option value="yes_no">Тийм/Үгүй</option>
                  <option value="multiple_choice">Олон сонголт</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>Тайлбар</label>
                <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                  style={{ ...inputStyle, minHeight: 60 }} />
              </div>
              <div>
                <label style={labelStyle}>Кворум (%)</label>
                <input type="number" value={form.quorum_percent} onChange={e => setForm({ ...form, quorum_percent: e.target.value })} style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Сонголтууд</label>
              {form.options.map((opt, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                  <input value={opt} onChange={e => {
                    const opts = [...form.options];
                    opts[i] = e.target.value;
                    setForm({ ...form, options: opts });
                  }} style={{ ...inputStyle, flex: 1 }} />
                  {form.options.length > 2 && (
                    <button type="button" onClick={() => setForm({ ...form, options: form.options.filter((_, j) => j !== i) })}
                      style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: 4, padding: '0 10px', cursor: 'pointer' }}>✕</button>
                  )}
                </div>
              ))}
              <button type="button" onClick={() => setForm({ ...form, options: [...form.options, ''] })}
                style={{ background: '#e8e5dc', border: 'none', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13, color: '#2a3b32' }}>
                + Сонголт нэмэх
              </button>
            </div>
            <button type="submit" style={btnPrimary}>Үүсгэх</button>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <div style={{ display: 'grid', gap: 16 }}>
          {polls.map((poll: any) => (
            <div key={poll.id} style={card}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 12 }}>
                <div>
                  <h3 style={{ margin: 0, marginBottom: 4 }}>{poll.title}</h3>
                  <div style={{ display: 'flex', gap: 8, fontSize: 13, color: '#64748b' }}>
                    <span>{POLL_TYPES[poll.poll_type] || poll.poll_type}</span>
                    <span>|</span>
                    <span>Кворум: {poll.quorum_percent}%</span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span style={{
                    background: (STATUS_COLORS[poll.status] || '#6b7280') + '20',
                    color: STATUS_COLORS[poll.status] || '#6b7280',
                    padding: '2px 10px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                  }}>{poll.status}</span>
                  {poll.status === 'draft' && (
                    <button onClick={() => activatePoll(poll.id)} style={{
                      background: '#10b981', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13,
                    }}>Идэвхжүүлэх</button>
                  )}
                  {poll.status === 'active' && (
                    <button onClick={() => closePoll(poll.id)} style={{
                      background: '#ef4444', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13,
                    }}>Хаах</button>
                  )}
                  <button onClick={() => deletePoll(poll)} title="Устгах" style={{
                    background: 'transparent', color: '#ef4444', border: '1px solid #ef4444', padding: '4px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13,
                  }}>Устгах</button>
                </div>
              </div>
              {poll.description && <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 12px' }}>{poll.description}</p>}
              {(() => {
                const opts: any[] = poll.options || [];
                const total = opts.reduce((a: number, o: any) => a + (o.vote_count || 0), 0);
                const voted = poll.total_voted || total;
                const eligible = poll.total_eligible || 0;
                const turnout = eligible ? Math.round(voted * 100 / eligible) : 0;
                const quorumOk = eligible > 0 && turnout >= (poll.quorum_percent || 0);
                const max = Math.max(0, ...opts.map((o: any) => o.vote_count || 0));
                return (
                  <div style={{ display: 'grid', gap: 8 }}>
                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', fontSize: 13, color: '#2a3b32' }}>
                      <span><b>{voted}</b> санал{eligible ? <> / {eligible} айл (<b>{turnout}%</b>)</> : null}</span>
                      {eligible > 0 && <span style={{ color: quorumOk ? '#2f7a4a' : '#b3412f', fontWeight: 600 }}>{quorumOk ? '✓ Кворум хүрсэн' : `Кворум хүрээгүй (${poll.quorum_percent}% шаардлагатай)`}</span>}
                    </div>
                    {opts.map((o: any) => {
                      const pct = total ? Math.round((o.vote_count || 0) * 100 / total) : 0;
                      const lead = total > 0 && (o.vote_count || 0) === max;
                      return (
                        <div key={o.id} style={{ position: 'relative', borderRadius: 8, background: '#f3f1ea', overflow: 'hidden' }}>
                          <div style={{ position: 'absolute', inset: 0, width: `${pct}%`, background: lead ? '#cfe6d6' : '#e2ded2', transition: 'width .3s' }} />
                          <div style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', gap: 10, padding: '7px 12px', fontSize: 14 }}>
                            <span style={{ fontWeight: lead ? 700 : 500 }}>{o.label}</span>
                            <span style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{o.vote_count || 0} санал · {pct}%</span>
                          </div>
                        </div>
                      );
                    })}
                    {total === 0 && <div style={{ fontSize: 13, color: '#8a978f' }}>Санал өгөөгүй байна{poll.status === 'draft' ? ' — идэвхжүүлснээр оршин суугчдын QR хуудсанд гарна' : ''}.</div>}
                  </div>
                );
              })()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
